import React from 'react'
import { initializeApollo } from 'gql/client'
import { PAGINA } from 'utils/queries'
import { useUnsubsQuery } from '@gql/graphql'
import UnsubscribeTemplate from 'components/templates/UnsubscribeTemplate/UnsubscribeTemplate'
import { PaginaType } from '../../utils/types'
import { useRouter } from 'next/dist/client/router'
import Custom404 from '@pages/404'
import { NextWrapper } from 'data-fetching-wrapper'

interface Props {
  pagina: PaginaType
}

const UnsubscribePage = ({ pagina }: Props) => {
  const router = useRouter()
  const token = router.query?.token
  const { data, loading, error } = useUnsubsQuery()
  const unsubs = data?.unsubs

  if (error) {
    return <Custom404 />
  }

  return <UnsubscribeTemplate pagina={pagina} unsubs={unsubs} token={token} />
}

export const getStaticProps = NextWrapper.getStaticProps(async () => {
  const client = initializeApollo()

  const {
    data: { pagina },
  } = await client.query({
    query: PAGINA,
    variables: { chiave: 'unsubscribe' },
  })

  if (!pagina) {
    return {
      notFound: true,
    }
  }

  return {
    props: { pagina }, // will be passed to the page component as props
  }
}, '/unsubscribe')

export default UnsubscribePage
